import { BASE_URL } from "./constants";

/**
 * Backend se aaye image path ko poori URL me badalta hai.
 *
 * Do cheezein handle karta hai:
 * 1. Host BASE_URL se aata hai, hardcoded nahi - pehle yahan m6.microlent.com
 *    hardcoded tha jo dead server hai, aur woh screens chup-chaap toot rahi thi.
 * 2. Windows (IIS) pe multer backslash wale path deta hai, jo URL me invalid
 *    hai. Kai API fields raw DB path bhejti hain, isliye normalize zaroori hai.
 *
 * Jo path already absolute URL hai use jaisa hai waisa return karta hai.
 */
export const getImageUrl = (path?: string | null): string => {
  if (!path) return "";
  if (/^https?:\/\//i.test(path)) return path;

  const clean = String(path)
    .replace(/\\/g, "/")
    .replace(/^\/+/, "");

  return `${BASE_URL.replace(/\/+$/, "")}/${clean}`;
};
